import React from "react";
import { Row, Col } from "react-bootstrap";

function CancelApprovalRequestBtn({ onClick, style }) {
  return (
    <>
      <Col xs={4}></Col>
      <Col xs={6}>
        <Row>
          <button type="button" className="btn btn-danger" style={style} onClick={onClick}>
            <i className="fa fa-ban"></i> Cancel Approval
          </button>
        </Row>
      </Col>
    </>
  );
}

export default CancelApprovalRequestBtn;
